import { ProductType } from "./productType.model";

export interface ICharacteristics {
  id?: number;
  name?: string;
  description?: string;
  productType?: ProductType;
  //countryCharacteristic?: string;
  characteristic_value?: string,
  isRequiredValue?: boolean;
  slug?: string;
}

export class Characteristics implements ICharacteristics{
  constructor(
    public id?: number,
    public name?: string,
    public description?: string,
    public productType?: ProductType,
    //public countryCharacteristic?: string,
    public characteristic_value?: string,
    public isRequiredValue?: boolean,
    public slug?: string,
  ){
    this.id = id;
    this.name = name;
    this.description = description;
    this.productType = productType;
    //this.countryCharacteristic = countryCharacteristic;
    this.characteristic_value = characteristic_value;
    this.isRequiredValue = isRequiredValue;
    this.slug = slug;
  }
}
